var React = require('react');

function IconFacebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.984 5.488H0v2.645h1.984v7.935H5.29V8.133h2.408l.237-2.645H5.29V4.385c0-.631.127-.881.737-.881h1.908V.198H5.417c-2.378 0-3.433 1.047-3.433 3.052v2.238z"}));
}

IconFacebook.defaultProps = {"width":"8","height":"17","fill":"#fff"};

module.exports = IconFacebook;

IconFacebook.default = IconFacebook;
